import { render } from "./AsideMenuList.vue?vue&type=template&id=427674f1"
import script from "./AsideMenuList.vue?vue&type=script&lang=js"
export * from "./AsideMenuList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/project-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__